const emptyLocale = {
  title: "暂无数据",
  actionText: "操作"
};
export {
  emptyLocale
};
//# sourceMappingURL=zh_CN.js.map
